/** Must stay in sync with LumoPagesApp `src/util/cookieConsentCrossDomain.js`. */

export const COOKIE_CONSENT_NAME = "cookieConsent";

const MAX_AGE_SECONDS = 60 * 60 * 24 * 400;

function parseCookie(name) {
  if (typeof document === "undefined") return null;
  const parts = document.cookie.split(";");
  for (const part of parts) {
    const idx = part.indexOf("=");
    if (idx === -1) continue;
    const k = part.slice(0, idx).trim();
    if (k !== name) continue;
    const raw = part.slice(idx + 1).trim();
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }
  return null;
}

export function getCookieConsentFromDocument() {
  const v = parseCookie(COOKIE_CONSENT_NAME);
  if (v === "accepted" || v === "rejected") return v;
  return null;
}

export function setCrossDomainCookieConsent(value) {
  if (typeof document === "undefined") return;
  const hostname = window.location.hostname;
  let domainAttr = "";
  if (hostname === "lumopages.com" || hostname.endsWith(".lumopages.com")) {
    domainAttr = "; domain=.lumopages.com";
  }
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE_CONSENT_NAME}=${encodeURIComponent(
    value,
  )}; path=/; max-age=${MAX_AGE_SECONDS}; SameSite=Lax${secure}${domainAttr}`;
  try {
    localStorage.setItem("cookieConsent", value);
    localStorage.setItem("cookieConsent.updatedAt", new Date().toISOString());
  } catch {
    /* ignore */
  }
}
